import { useEffect, forwardRef } from "react";
import "./Hero.css";
import AOS from "aos";

const Hero = forwardRef((props, ref) => {
  const { aboutRef } = props;

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  const scrollToContact = () => {
    const bottomPosition = aboutRef.current.offsetTop + aboutRef.current.offsetHeight-90;
    window.scrollTo({
      top: bottomPosition,
      behavior: "smooth",
    });
  };

  return (
    <main ref={ref} className="hero-video-container" id={0}>
      <div className="hero-overlay pt-4">
        {/*<div className="hero-img">
          <img src={background} alt="" />
        </div>
        */}
        <div className="hero-text-wrapper">
          <h2
            className="hero-text-title"
            data-aos="fade-up"
            data-aos-once="true"
          >
            ¿Tenés deudas y no sabés cómo salir o por donde empezar?
          </h2>

          <p
            className="hero-text-description"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-once="true"
          >
            Tu deuda tiene solución. Sabemos cómo ayudarte.
          </p>

          <button
            className="hero-button"
            onClick={scrollToContact}
            data-aos="fade-up"
            data-aos-delay="400"
            data-aos-once="true"
          >
            Contactanos
          </button>
        </div>
      </div>
    </main>
  );
});

export default Hero;
